import { useAppStore } from '@/store/modules/app'
import { watch } from 'vue'

const domSymbol = Symbol('watermark-dom')
export interface WatermarkOptions {
  fontSize?: number
  color?: string
  gap?: number
  opacity?: number
}

export function useWatermark(appendEl: HTMLElement | null = document.body) {
  let func: Fn = () => {}
  const id = domSymbol.toString()
  const appStore = useAppStore()
  let watermarkStr = ''
  let watermarkOptions: WatermarkOptions = {}

  const clear = () => {
    const domId = document.getElementById(id)
    if (domId) {
      const el = appendEl
      el && el.removeChild(domId)
    }
    window.removeEventListener('resize', func)
  }
  const createWatermark = (str: string, options: WatermarkOptions = {}) => {
    clear()

    const can = document.createElement('canvas')
    const cans = can.getContext('2d')
    if (cans) {
      const fontSize = options.fontSize ?? 30
      const gap = options.gap ?? 80
      const opacity = Math.min(100, Math.max(1, options.opacity ?? 6)) / 100
      cans.font = `${fontSize}px Verdana`
      can.width = Math.ceil(cans.measureText(str).width + gap)
      can.height = Math.ceil(fontSize + gap)
      cans.rotate((-20 * Math.PI) / 180)
      cans.font = `${fontSize}px Verdana`
      const color = options.color || (appStore.getIsDark ? '#ffffff' : '#000000')
      const rgb = color.match(/[a-f\d]{2}/gi)?.map((hex) => parseInt(hex, 16)) || [0, 0, 0]
      cans.fillStyle = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity})`
      cans.textAlign = 'left'
      cans.textBaseline = 'middle'
      cans.fillText(str, gap / 2, can.height / 2)
    }

    const div = document.createElement('div')
    div.id = id
    div.style.pointerEvents = 'none'
    div.style.top = '0px'
    div.style.left = '0px'
    div.style.position = 'absolute'
    div.style.zIndex = '100000000'
    div.style.width = document.documentElement.clientWidth + 'px'
    div.style.height = document.documentElement.clientHeight + 'px'
    div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
    const el = appendEl
    el && el.appendChild(div)
    return id
  }

  function setWatermark(str: string, options: WatermarkOptions = {}) {
    watermarkStr = str
    watermarkOptions = options
    createWatermark(str, options)
    func = () => {
      createWatermark(str, options)
    }
    window.addEventListener('resize', func)
  }

  // 监听主题变化
  watch(
    () => appStore.getIsDark,
    () => {
      if (watermarkStr) {
        createWatermark(watermarkStr, watermarkOptions)
      }
    }
  )

  return { setWatermark, clear }
}
